import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { buildMediaUrl } from '../../../utils/mediaUrl';

const GalleryPreview = ({ isAdminPreview = true }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const res = await api.get('/business/gallery/');
      setItems(res.data || []);
    } catch (err) {
      console.error('Error fetching gallery:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    if (isAdminPreview) {
      const interval = setInterval(fetchData, 2000);
      return () => clearInterval(interval);
    }
  }, [isAdminPreview]);

  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <div style={{
          width: '2rem', height: '2rem',
          border: '3px solid rgba(255,255,255,0.1)',
          borderTopColor: '#6366f1',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto'
        }} />
      </div>
    );
  }

  if (!items.length) {
    return (
      <div style={{
        padding: '2rem',
        textAlign: 'center',
        color: 'rgba(255,255,255,0.5)',
        backgroundColor: '#1e293b',
        minHeight: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        No gallery images added yet.
      </div>
    );
  }

  return (
    <div style={{ padding: '1.5rem', backgroundColor: '#1e293b', minHeight: '200px' }}>
      <h2 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#fff', textAlign: 'center', marginBottom: '1.5rem' }}>
        Gallery
      </h2>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '0.5rem'
      }}>
        {items.slice(0, 6).map((item, index) => (
          <div
            key={item.id || index}
            style={{
              aspectRatio: '1',
              borderRadius: '0.5rem',
              overflow: 'hidden'
            }}
          >
            <img
              src={buildMediaUrl(item.image)}
              alt={item.title || `Gallery ${index + 1}`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default GalleryPreview;
